import type { ResourceName } from "@Common/types/resources";

export const resourceName: { name: ResourceName } = { name: "forms_public" };
